// extracted by mini-css-extract-plugin
export default {"aboutContent":"About_aboutContent__2XHIw","aboutText":"About_aboutText__HMZGP","aboutImage":"About_aboutImage__4-KPJ"};